import AdenLocalStorage from '@/utils/storage.util';
import StorageConst from '@/consts/storage.const';
import AdenRequest from './request';
import { ElMessage } from 'element-plus';

const Aden = new AdenRequest({
  baseURL: process.env.VUE_APP_API_TARGET.replace('http:', window.location.protocol),
  interceptors: {
    requestSuccessFn: (config: any) => {
      // 通过axios 请求拦截时添加token信息
      const token = AdenLocalStorage.get(StorageConst.STORAGE_KEY_TOKEN);
      if (config.headers && token) {
        // 类型缩小
        config.headers.Authorization = 'Bearer ' + token;
      }
      return config;
    },
    responseFailureFn: (response: any) => {
      // 处理响应数据
      if (response) {
        return response.response; // 确保在失败时 reject
      }
    },
  },
});

// 使用Aden做为本系统的api调用方法
export default Aden;
